/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import {
  TYPE_APARTMENT,
  TYPE_COMMERCIAL_PREMISE,
  TYPE_HOUSE,
  TYPE_TERRAIN
} from '../../enums/EstateTypeCodes.mjs'
import Filter, { FilterableProps } from '../Filter'
import useArrayFilter from '../../../../client/js/hooks/useArrayFilter'
import { Checkbox, Radio } from '@mantine/core'

function EstateTypeFilter (props: FilterableProps<string[]>) {
  const { onChange, value } = props
  const intl = useIntl()
  const [array, handleChange] = useArrayFilter(value, onChange)
  return (
    <Filter>
      <Radio
        checked={array.length === 0}
        id="estate_type_all_filter"
        label={intl.formatMessage({
          id: 'all',
          defaultMessage: 'Tout'
        })}
        name="type"
        onChange={(event) => {
          if (event.target.checked) {
            onChange(event.target.name, undefined)
          }
        }}
        value=""
      />
      <Checkbox
        checked={array.includes(TYPE_APARTMENT)}
        id="estate_type_apartment_filter"
        label={intl.formatMessage({
          id: 'apartment',
          defaultMessage: 'Appartement'
        })}
        name="type"
        onChange={handleChange}
        value={TYPE_APARTMENT}
      />
      <Checkbox
        checked={array.includes(TYPE_HOUSE)}
        id="estate_type_house_filter"
        label={intl.formatMessage({
          id: 'house',
          defaultMessage: 'Maison'
        })}
        name="type"
        onChange={handleChange}
        value={TYPE_HOUSE}
      />
      <Checkbox
        checked={array.includes(TYPE_COMMERCIAL_PREMISE)}
        id="estate_type_commercial_premise_filter"
        label={intl.formatMessage({
          id: 'commercial_premise',
          defaultMessage: 'Local'
        })}
        name="type"
        onChange={handleChange}
        value={TYPE_COMMERCIAL_PREMISE}
      />
      <Checkbox
        checked={array.includes(TYPE_TERRAIN)}
        id="estate_type_terrain_filter"
        label={intl.formatMessage({
          id: 'terrain',
          defaultMessage: 'Terrain'
        })}
        name="type"
        onChange={handleChange}
        value={TYPE_TERRAIN}
      />
    </Filter>
  )
}

export default EstateTypeFilter
